import React, { useMemo } from 'react';

import {
  Row,
  Col,
  Button
} from 'reactstrap';

import FieldError from '../../../../../../helper/FieldError';

import WorkflowHttpRequestBodyRequestHeaderItemForm from './item_form';

const WorkflowHttpRequestBodyRequestHeaderList = props => {
  const { currentNode } = props;
  const {
    callbacks: {
      onAddHeaderRequestContentItem: callbackOnAddHeaderRequestContentItem,
      onRemoveHeaderRequestContentItem: callbackOnRemoveHeaderRequestContentItem,
      onChangeHeaderRequestContentItem: callbackOnChangeHeaderRequestContentItem
    }
  } = props;

  const headerRequestContent = useMemo(() => {
    return currentNode?.data?.header_request_content || [];
  }, [currentNode?.data?.header_request_content])

  return(
    <Row>
      <Col md={ 12 }>
        <FieldError errors={ _.get(currentNode, 'data.errors.header_request_content') }>
          { _.map(headerRequestContent, (headerRequestContentItem, index) => {
            return(
              <WorkflowHttpRequestBodyRequestHeaderItemForm
                key={ `WorkflowHttpRequestBodyRequestHeaderItemForm-${ headerRequestContentItem?.custom_id }` }
                currentNode={ currentNode }
                headerRequestContentItem={ headerRequestContentItem }
                callbacks={{
                  onChangeHeaderRequestContentItem: callbackOnChangeHeaderRequestContentItem,
                  onRemoveHeaderRequestContentItem: callbackOnRemoveHeaderRequestContentItem
                }}
              />
            )
          })}
        </FieldError>

        <div className='text-center'>
          <Button
            outline
            color='success'
            size="sm"
            onClick={ callbackOnAddHeaderRequestContentItem }
          >
            Add Header Request Content Item
          </Button>
        </div>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestBodyRequestHeaderList;
